// extracted by mini-css-extract-plugin
export default {"show_up":"show_up___ukB_C"};